import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { Select, message } from "antd";
import Swal from "sweetalert2";
import Hexapi from "../../utility/HexAPI/Hexapi";
import Inputbox from "../../components/formcontrols/normal/InputBox";
import Loader from "../../components/loader/Loader";


export default function SubordinateApprovalDialog({
  show,
  empId,
  empName,
  userId,
  onClose,
  onConfirm, 
}) {
  const [loading, setLoading] = useState(false);
  const [addingDept, setAddingDept] = useState(false);
  const [departmentList, setDepartmentList] = useState([]);
  const [departmentId, setDepartmentId] = useState(null);
  const [designation, setDesignation] = useState("");
  const [newDeptName, setNewDeptName] = useState("");
  const [selectOpen, setSelectOpen] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (show) {
      setErrors({});
      setNewDeptName("");
      fetchData();
    }

  }, [show]);

  const fetchData = () => {
    setLoading(true);
 setDesignation("");
setDepartmentId(null);
setDepartmentList([]);
    const obj = {
      query: `HRApp_Droid_Proc_User_Approvals_SubordinateApproval_GetData @EmpID='{0}',@UserID='{1}'`,
      queryArr: [`${empId}`, `${userId}`],
    };
    Hexapi(obj)
      .then((resp) => {
console.log(resp,"resp")
        const def = resp["def"] && resp["def"][0];
        const depts = resp["departments"] || [];
        setDepartmentList(depts);
        if (def ) {
if(def.departmentid != -1) {
          setDepartmentId(def.departmentid);
}
          setDesignation(def.designation);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("SubordinateApproval GetData error:", err);
        setLoading(false);
        Swal.fire({
          confirmButtonColor: "#28b6f6",
          text: "An error occurred while loading form data!",
        });
      });
  };

  const addNewDepartment = (name) => {
    if (!name || !name.trim()) return;
    setAddingDept(true);
    const obj = {
      query: `HRApp_Droid_Proc_AddDepartment_Submit @DepartmentName='{0}',@UserID='{1}'`,
      queryArr: [`${name}`, `${userId}`],
    };
    Hexapi(obj)
      .then((resp) => {
        setAddingDept(false);
console.log(resp,"resp")
        const newDept = resp?.["newdepartment"] && resp?.["newdepartment"]?.[0];
console.log(newDept)
        if (newDept && newDept?.command) {
          const updatedList = resp?.["departmentlist"];
          setDepartmentList(updatedList);
          setDepartmentId(newDept?.departmentid);
          setNewDeptName("");
          setSelectOpen(false);
          message.success(newDept?.msg );
        } else if (newDept?.msg) {
          message.error(newDept.msg);
        }
      })
      .catch((err) => {
        setAddingDept(false);
        console.error("AddDepartment error:", err);
      });
  };

  const handleValidation = () => {
    let errs = {};
    let valid = true;
    if (!departmentId) {
      errs.department = "Department is required";
      valid = false;
    }
    if (!designation || !designation.trim()) {
      errs.designation = "Designation is required";
      valid = false;
    }
    setErrors(errs);
    return valid;
  };

  const handleYes = () => {
    if (!handleValidation()) return;
    const remarks = `${departmentId}##12##${designation}`;
    onConfirm(remarks);
  };

  const departmentOptions = departmentList.map((d) => ({
    label: d.departmentname,
    value: d.departmentid,
  }));

  return (
    <Modal show={show} onHide={onClose} centered id="modalid">
      <Modal.Body style={{ padding: "15px" }}>
        <div style={{ marginBottom: "15px", textAlign: "left" }}>
          Are you sure you want to accept {empName}'s request?
        </div>

        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", padding: "20px 0" }}>
            <Loader />
          </div>
        ) : (
          <>
            <div className="form-group mb-3 subordinate-dept-select">
              <style>{`
                .subordinate-dept-select .ant-select-selector,
                .subordinate-dept-select .ant-select-selection-item,
                .subordinate-dept-select .ant-select-selection-search-input,
                .subordinate-dept-select .ant-select-selection-placeholder {
                  text-align: left !important;
                }
                .subordinate-dept-select .ant-select-dropdown .ant-select-item-option-content {
                  text-align: left !important;
                }
              `}</style>
              <label
                style={{
                  display: "flex",
                  color: (errors.department && !departmentId) ? "red" : "black",
                  fontWeight: "600",
                  textTransform: "uppercase",
                }}
              >
                Department<span style={{ color: "red" , marginLeft:"4px" , fontSize:"18px"}}>*</span>
              </label>
              <Select
                showSearch
                style={{ width: "100%" }}
                value={departmentId || undefined}
                placeholder="Select or type department"
                onChange={(value) => setDepartmentId(value)}
                loading={addingDept}
                optionFilterProp="label"
                options={departmentOptions}
                open={selectOpen}
                onDropdownVisibleChange={setSelectOpen}
                dropdownStyle={{ zIndex: 2000, textAlign: "left" }}
                getPopupContainer={(triggerNode) => triggerNode.parentElement}
                status={errors.department ? "error" : ""}
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <div style={{ borderTop: "1px solid #e8e8e8", margin: "4px 0" }} />
                    <div style={{ display: "flex", gap: "8px", padding: "6px 8px" }}>
                      <input
                        style={{
                          flex: 1,
                          border: "1px solid #d9d9d9",
                          borderRadius: "4px",
                          padding: "4px 8px",
                          fontSize: "13px",
                        }}
                        placeholder="New department name"
                        value={newDeptName}
                        onChange={(e) => setNewDeptName(e.target.value)}
                        onKeyDown={(e) => {
                          e.stopPropagation();
                          if (e.key === "Enter") {
                            e.preventDefault();
                            addNewDepartment(newDeptName.trim());
                          }
                        }}
                      />
                      <Button
                        size="sm"
                        variant="primary"
                        disabled={!newDeptName.trim() || addingDept}
                        onClick={() => addNewDepartment(newDeptName.trim())}
                      >
                        + Add
                      </Button>
                    </div>
                  </>
                )}
              />
            </div>

            <div className="mt-2">
              <Inputbox
                wordboundation={{ limit: 50, id: "designationInput" }}
                htmlFor={"DESIGNATION"}
                label={"DESIGNATION"}
                type="text"
                labelStyle={{ fontWeight: "500" , color :(errors.designation && !designation) ? "red" : "black" }}
                placeholder="Enter designation"
                value={designation}
                onChange={(e) => setDesignation(e.target.value)}
                required={true}
              />
            
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer style={{ border: "none", padding: "10px" }}>
        <Button variant="secondary" onClick={onClose} className="nobutton">
          <b>No</b>
        </Button>
        <Button variant="primary" onClick={handleYes} className="yesbutton" disabled={loading}>
          <b>Yes</b>
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
